export default "__VITE_ASSET__DwRwajwd__"